import React, { useState, useEffect } from "react";
import PerformanceChart from "./PerformanceChart";
import SelectComponent from "../../../../ReusableComponents/SelectComponent";
import Popup from "../../../../ReusableFunctions/Popup";
import { getBhuMeetPerformanceAPI } from "../apis";

const BhumeetEnabledStores = ({ labels, commonFilters }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [bhumeetPerformance, setBhumeetPerformance] = useState({});
  const [selectedStoreType, setSelectedStoreType] = useState({
    value: "Retailer",
    label: "Retailer"
  })

  const getBESPerformace = async () => {
    try {
      setIsLoading(true)
      const bhumeetPerformance = await getBhuMeetPerformanceAPI({ ...commonFilters, storeType: selectedStoreType.value, performanceType: "bes" })
      setBhumeetPerformance(bhumeetPerformance);
      setIsLoading(false)
    } catch (e) {
      Popup.alert("ERROR", "Error while getting performace data.", "ERROR")
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (commonFilters) getBESPerformace()
  }, [commonFilters, selectedStoreType]);


  const storeTypes = [{
    value: null,
    label: "All"
  }, {
    value: "Retailer",
    label: "Retailer"
  }, {
    value: "Individual",
    label: "Individual"
  }]

  return (
    <PerformanceChart
      header={{
        title: "BhuMeet Enabled Stores",
        rightContent: 
        <SelectComponent
          controlStyle={{ height: "30px", minHeight: "30px", background: "none", width: "150px", padding: "0px", border: "1px solid #ddd", boxShadow: "none", color: "hsl(0deg 0% 20% / 64%)", fontSize: "10px" }}
          isSearchable={true}
          menuStyles={{
            width: "150px"
          }}
          placeholder={"Select store type..."}
          menuPlacement={"bottom"}
          list={storeTypes}
          value={selectedStoreType}
          optionStyle={{
            fontSize: "12px",
            height: "30px",
            minHeight: "30px"
          }}
          valueContainerStyle={{
            marginTop: "-2px"
          }}
          indicatorsContainerStyle={{
            marginTop: "-3px"
          }}
          onChange={(store) => {
            setSelectedStoreType(store)
          }}
        />
      }}
      labels={labels}
      dataSetLabel="BES count"
      prevMonthData={bhumeetPerformance.prevMonthData || 0}
      performanceData={bhumeetPerformance.chartData || []}
      isLoading={isLoading} />
  );
};

export default BhumeetEnabledStores;
